import React, {useState, useEffect} from 'react';
import "../../../css/pages/investors.scss";
import cultur3capital from "../../../images/investors/cultur3capital.png";
import highgateventures from "../../../images/investors/highgateventures.png";
import parcapital from "../../../images/investors/parcapital.png";
import plugplayventures from "../../../images/investors/plugplayventures.png";
import thayerventures from "../../../images/investors/thayerventures.png";
import investorpattern from "../../../images/investors/investorpattern.png";
import { useHistory } from 'react-router-dom';

function Investors() {
    const history = useHistory();
    
    return (
        <div className='investors-container'>
            <div className='investors-content'>
                <img className="investor-pattern" src={investorpattern} alt="investorpattern image"></img>
                <h3>Investors</h3>
                <div className='row investors-grid'>
                    <div className='col-4'>
                        <div className='image-div'>
                            <div className='image parcapital-image'>
                                <img className='parcapital' src={parcapital} alt="parcapital image"/>
                            </div>
                            <p>PAR Capital</p>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='image-div'>
                            <div className='image thayerventures-image'>
                                <img className='thayerventures' src={thayerventures} alt="thayerventures image"/>
                            </div>
                            <p>Thayer Ventures</p>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='image-div'>
                            <div className='image cultur3capital-image'>
                                <img className='cultur3capital' src={cultur3capital} alt="cultur3capital image"/>
                            </div>
                            <p>Cultur3 Capital</p>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='image-div'>
                            <div className='image plugplayventures-image'>
                                <img className='plugplayventures' src={plugplayventures} alt="plugplayventures image"/>
                            </div>
                            <p>Plug and Play Ventures</p>
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='image-div'>
                            <div className='image highgateventures-image'> 
                                <img className='highgateventures' src={highgateventures} alt="highgateventures image"/>
                            </div>
                            <p>Highgate Ventures</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Investors;